import { Box, ColorOptions, Icon, ModBox, Spacer, Text, TextInputNew, TextInputNewProps } from '@jfs/ui-new'
import { useRef, useState } from 'react'
import { TextInput } from 'react-native'
import { DropdownOptimised } from '../../comps/DropdownNew'
import { MultiselectDropdown } from '../../comps/MultiSelectDropdown'
import { TextInputWithDelete } from '../../comps/TextInputWithDelete'
import { useStores } from '../../data/store'
import { Colors } from '../../util/util'
import { TenureROI } from './TenureROI'
import { TxnAttributeComp } from './TxnAttributeComp'

const tenureData = [
  { id: '1', value: '3M' },
  { id: '2', value: '6M' },
  { id: '3', value: '9M' },
  { id: '4', value: '12M' },
  { id: '5', value: '18M' },
  { id: '6', value: '24M' },
]

export const RuleConfig = ({ value, setFieldValue, fieldName, disabled, updatePaymentMode }: any) => {
  const [txnKey, setTxnKey] = useState<string>(value?.txnAmountKey)
  const [paymentMode, setPaymentMode] = useState<string>(value?.paymentMode)
  const [emiBankName, setEmiBankName] = useState<string>(value?.emiBankName)

  const [paymentInstruements, setPaymentInstruements] = useState<string[]>(value?.paymentInstrument)
  const [purchaseType, setPurchaseType] = useState<string[]>(value?.purchaseType)
  const [emiTenure, setEmiTenure] = useState<string>(value?.emiTenure) //card

  const [txnAmountError, setTxnAmountError] = useState('')
  const [maxAmountError, setMaxAmountError] = useState('')
  const [minAmountError, setMinAmountError] = useState('')

  const binRef = useRef<TextInput>(null)
  const {
    allPaymentModes,
    getInstruments,
    updateProductSelection,
    products,
    ruleConfigErrors,
    updateRuleConfigError,
    count,
    setAttributesCount,
  } = useStores((store: any) => ({
    allPaymentModes: store.campaigns.paymentModes,
    getInstruments: store.campaigns.getInstruments,
    updateProductSelection: store.campaigns.updateProductSelection,
    products: store.campaigns.getAllProducts(),
    updateRuleConfigError: store.campaigns.updateRuleConfigError,
    ruleConfigErrors: store.campaigns.getRuleConfigErrors(),
    count: store.campaigns.getAttributesCount(),
    setAttributesCount: store.campaigns.updateTxnAttributesCount,
    getNoCostEmiBanksList: store.campaigns.getNoCostEmiBanksList,
  }))

  const [tenureRoiArr, setTenureRoiArr] = useState(
    value?.tenure?.length > 0 ? Array(value?.tenure?.length)?.fill(1) : [1],
  )
  const payMode = paymentMode === 'NetBanking' ? 'Bank' : paymentMode
  const instruments = getInstruments(payMode)
  const [data, setData] = useState(instruments ?? [])
  const handlePaymentModeChange = (val: any) => {
    updateRuleConfigError('paymentMode', null)
    setPaymentMode(val)
    updatePaymentMode(val)
    const type = val === 'NetBanking' ? 'Bank' : val
    const arr = getInstruments(type)
    setPaymentInstruements([])
    setEmiBankName(undefined)
    setFieldValue(fieldName, {
      ...value,
      paymentMode: val,
      bin: undefined,
      paymentInstrument: undefined,
      emiBankName: undefined,
    })
    setData(arr)
  }

  const handleTxnTypeChange = (val: any) => {
    setTxnKey(val)
    setFieldValue(fieldName, { ...value, txnAmountKey: val })
    updateRuleConfigError('txnAmountKey', null)
  }

  const handleEmiBankChange = (val: any) => {
    setEmiBankName(val)
    setFieldValue(fieldName, { ...value, emiBankName: val })
    updateRuleConfigError('emiBankName', null)
  }

  const handleEmiTenureChange = (val: any) => {
    setEmiTenure(val)
    setFieldValue(fieldName, { ...value, emiTenure: val })
    updateRuleConfigError('emiTenure', null)
  }

  const onTxnAmountChange = (val: string) => {
    setFieldValue(fieldName, { ...value, txnAmount: val })
    updateRuleConfigError('txnAmount', null)
  }
  const onMaxLimitChange = (val: string) => {
    setFieldValue(fieldName, { ...value, maxLimit: val })
  }
  const handlePaymentInstrumentChange = (val: any) => {
    setPaymentInstruements(val)
    setFieldValue(fieldName, { ...value, paymentInstrument: val })
    updateRuleConfigError('paymentInstrument', null)
  }

  const handlePurchaseTypeChange = (val: any) => {
    setPurchaseType(val)
    setFieldValue(fieldName, { ...value, purchaseType: val })
    updateRuleConfigError('purchaseType', null)
  }
  const onBinChange = (val: any) => {
    setFieldValue(fieldName, { ...value, bin: val })
    updateRuleConfigError('bin', null)
  }

  const onTxnAmountBlur = () => {
    const regex = new RegExp(/^\d+(\.\d{1,2})?$/)
    if (!!txnKey && txnKey !== 'Range' && !regex.test(value.txnAmount)) {
      setTxnAmountError('Invalid amount.')
    }
  }

  const onMaxAmountBlur = () => {
    const regex = new RegExp(/^\d+(\.\d{1,2})?$/)
    if (!regex.test(value.maxAmount)) {
      setMaxAmountError('Invalid amount.')
    } else {
      if (!!value.minAmount && Number(value?.maxAmount) <= 0 && Number(value.minAmount) > Number(value.maxAmount)) {
        setMaxAmountError('Invalid amount.')
      }
    }
  }

  const onMinAmountBlur = () => {
    const regex = new RegExp(/^\d+(\.\d{1,2})?$/)
    if (!!txnKey && txnKey === 'Range' && !regex.test(value.minAmount)) {
      setMinAmountError('Invalid amount.')
    } else {
      if (!!value.maxAmount && Number(value?.minAmount) <= 0 && Number(value.minAmount) > Number(value.maxAmount)) {
        setMinAmountError('Invalid amount.')
      }
    }
  }

  const onAmountRangeFocus = () => {
    setMinAmountError('')
    setMinAmountError('')
    updateRuleConfigError('minAmount', null)
    updateRuleConfigError('maxAmount', null)
  }

  const handleRule2Collapse = () => {
    setAttributesCount(0)
    for (let i = 1; i <= count; i++) {
      updateRuleConfigError([`txnAttributeKey${i}`], null)
      updateRuleConfigError([`txnAttributeIncluded${i}`], null)
      updateRuleConfigError([`txnAttributeExcluded${i}`], null)
      setFieldValue(fieldName, { ...value, [`txnAttributeKey${i}`]: null })
      setFieldValue(fieldName, { ...value, [`txnAttributeIncluded${i}`]: null })
      setFieldValue(fieldName, { ...value, [`txnAttributeExcluded${i}`]: null })
    }
  }

  const handleAddNewRulePress = () => {
    setAttributesCount(1)
  }

  const percentComp = () => {
    return <Text fontSize={12} fontFamily={'jiotype-medium'} color={Colors.FONT_COLOR as ColorOptions} title={'In %'} />
  }

  const tenureComp = () => {
    return (
      <Text fontSize={12} fontFamily={'jiotype-medium'} color={Colors.FONT_COLOR as ColorOptions} title={'In Months'} />
    )
  }

  const lockComp = () => {
    if (!disabled) {
      return null
    }
    return <Icon id={'LOCK'} size={12} color={'TEXT_PRIMARY' as ColorOptions} />
  }

  const paymentInstrumentLabel = paymentMode === 'NetBanking' ? 'Issuing Bank *' : 'Payment Instrument *'
  return (
    <Box key={'ruleconfig'}>
      <Box borderWidth={1} borderColor={Colors.BORDER_LIGHT_BLUE as ColorOptions} borderRadius={4}>
        <Box
          flexDirection={'row'}
          justify={'space-between'}
          align={'center'}
          pv={16}
          ph={24}
          borderTopRightRadius={4}
          borderTopLeftRadius={4}
          bg={Colors.BG_LIGHT_BLUE as ColorOptions}>
          <Text fontFamily={'jiotype-medium'} fontSize={12} color={'BLACK_21'}>
            RULE 01
          </Text>
          <Box bg={'PRIMARY_GREY'} w={12} h={1.5} />
        </Box>
        <Spacer size={16} direction={'vertical'} />
        <Box ph={16}>
          <Text
            fontFamily={'jiotype-medium'}
            fontSize={12}
            color={Colors.LABEL_GREY as ColorOptions}
            title={'Transaction / Event Type'}
          />
          <Spacer size={8} direction={'vertical'} />
          <Box borderWidth={1} borderColor={Colors.BORDER_LIGHT_BLUE as ColorOptions} ph={16} pv={12} borderRadius={4}>
            <Text
              fontFamily={'jiotype-medium'}
              fontSize={12}
              color={Colors.LABEL_GREY as ColorOptions}
              title={'Successful Transaction'}
            />
          </Box>
        </Box>
        <Box bg={Colors.BG_LIGHT_BLUE as ColorOptions} borderRadius={4} m={16} pv={24} ph={16}>
          <Text
            title={'+ Add Transaction attribute'}
            color={Colors.LABEL_GREY as ColorOptions}
            fontSize={12}
            fontFamily={'jiotype-medium'}
          />
          <Box flexDirection={'row'} pt={24}>
            <Box f={0.5} marginRight={16}>
              <DropdownOptimised
                label={'Transaction Type *'}
                labelPaddingBottom={8}
                labelColor={Colors.LABEL_GREY as ColorOptions}
                borderColor={Colors.BORDER_LIGHT_BLUE as ColorOptions}
                titleColor={Colors.FONT_GREY as ColorOptions}
                chevronColor={'BLACK_75'}
                labelFontFamily={'jiotype-medium'}
                placeHolder={txnKey ?? 'Transaction Type'}
                onChange={handleTxnTypeChange}
                error={ruleConfigErrors.txnAmountKey}
                disabled={disabled}
                disabledBg={'WHITE'}
                touched={true}
                data={[
                  { id: 1, value: 'Greater than' },
                  { id: 2, value: 'Less than' },
                  { id: 3, value: 'Range' },
                ]}
              />
            </Box>
            <Box f={0.5} h={80} pt={1}>
              <TextInputNew
                placeholder={'Transaction Amount'}
                label={'Transaction Amount *'}
                paddingVertical={8}
                value={value?.txnAmount}
                onChangeText={onTxnAmountChange}
                hide={txnKey === 'Range'}
                editable={!!txnKey && !disabled}
                rightComponent={lockComp()}
                touched
                error={txnAmountError || ruleConfigErrors.txnAmount}
                onBlur={onTxnAmountBlur}
                onFocus={() => [setTxnAmountError(''), updateRuleConfigError('txnAmount', null)]}
                {...styles.textinputStyle}
              />
              <ModBox show={txnKey === 'Range'} flexDirection={'row'}>
                <Box f={0.5}>
                  <TextInputNew
                    placeholder={'Max Amount'}
                    label={'Max Amount'}
                    paddingVertical={8}
                    value={value?.maxAmount}
                    editable={!!txnKey && !disabled}
                    rightComponent={lockComp()}
                    onBlur={onMaxAmountBlur}
                    onFocus={onAmountRangeFocus}
                    error={maxAmountError || ruleConfigErrors.maxAmount}
                    touched
                    onChangeText={(val: string) => setFieldValue(fieldName, { ...value, maxAmount: val })}
                    {...styles.textinputStyle}
                  />
                </Box>
                <Spacer direction={'horizontal'} size={16} />
                <Box f={0.5}>
                  <TextInputNew
                    placeholder={'Min Amount'}
                    label={'Min Amount'}
                    editable={!!txnKey && !disabled}
                    rightComponent={lockComp()}
                    value={value?.minAmount}
                    paddingVertical={8}
                    onBlur={onMinAmountBlur}
                    onFocus={onAmountRangeFocus}
                    error={minAmountError || ruleConfigErrors.minAmount}
                    touched
                    onChangeText={(val: string) => setFieldValue(fieldName, { ...value, minAmount: val })}
                    {...styles.textinputStyle}
                  />
                </Box>
              </ModBox>
            </Box>
          </Box>
          <Spacer size={8} direction={'vertical'} />
          <Box flexDirection={'row'}>
            <Box f={0.5} marginRight={16} h={82}>
              <DropdownOptimised
                label={'Payment Mode *'}
                labelPaddingBottom={8}
                placeHolder={paymentMode ?? 'Payment Mode'}
                labelColor={Colors.LABEL_GREY as ColorOptions}
                borderColor={Colors.BORDER_LIGHT_BLUE as ColorOptions}
                titleColor={Colors.FONT_GREY as ColorOptions}
                labelFontFamily={'jiotype-medium'}
                onChange={handlePaymentModeChange}
                data={[...allPaymentModes, { id: '4', value: 'No Cost EMI', selected: 'false' }]}
                error={ruleConfigErrors.paymentMode}
                touched
                disabled={disabled}
                disabledBg={'WHITE'}
                boxheight={40}
              />
            </Box>
            <ModBox f={0.5} show={paymentMode !== 'No Cost EMI'} h={82}>
              {paymentMode !== 'Card' && (
                <MultiselectDropdown
                  testID="paymentInstrument-"
                  label={paymentInstrumentLabel}
                  data={data}
                  touched
                  isMultiSelect={true}
                  fieldName={'paymentInstrument'}
                  fontFamily={'jiotype-medium'}
                  setFieldValue={(_, val: any) => handlePaymentInstrumentChange(val)}
                  value={paymentInstruements}
                  checkboxColor={Colors.BG_BLUE as ColorOptions}
                  selectedTextBackgroundClor={Colors.BG_BLUE_LIGHT as ColorOptions}
                  selectedTextBorderColor={Colors.BORDER_LIGHT_BLUE as ColorOptions}
                  error={ruleConfigErrors.paymentInstrument}
                  disabled={disabled}
                />
              )}
              {paymentMode === 'Card' && (
                <MultiselectDropdown
                  label={'Purchase Type'}
                  data={[
                    { id: '1', value: 'Regular Purchase' },
                    { id: '2', value: 'EMI Purchase' },
                  ]}
                  touched
                  isMultiSelect={true}
                  fieldName={'purchaseType'}
                  setFieldValue={(_, val: any) => handlePurchaseTypeChange(val)}
                  value={purchaseType}
                  checkboxColor={Colors.BG_BLUE as ColorOptions}
                  selectedTextBackgroundClor={Colors.BG_BLUE_LIGHT as ColorOptions}
                  selectedTextBorderColor={Colors.BORDER_LIGHT_BLUE as ColorOptions}
                  error={ruleConfigErrors.purchaseType}
                  disabled={disabled}
                />
              )}
            </ModBox>
          </Box>
          <ModBox show={paymentMode === 'No Cost EMI'} height={80 * tenureRoiArr?.filter((item) => item === 1)?.length}>
            {tenureRoiArr?.map((_, index) => {
              return (
                <TenureROI
                  value={value}
                  setFieldValue={setFieldValue}
                  fieldName={fieldName}
                  updateRuleConfigError={updateRuleConfigError}
                  ruleConfigErrors={ruleConfigErrors}
                  editable={!disabled}
                  rightComponent={lockComp()}
                  percentComp={percentComp()}
                  tenureComp={tenureComp()}
                  setTenureRoiArr={setTenureRoiArr}
                  tenureRoiArr={tenureRoiArr}
                  index={index}
                  key={'tenure' + index}
                  emiBanksList={getInstruments('bankEmiId')}
                />
              )
            })}
          </ModBox>
          <ModBox h={72} show={paymentMode === 'Card' || paymentMode === 'No Cost EMI'} flexDirection={'row'}>
            <Box f={0.5} h={72}>
              <TextInputNew
                placeholder={'Maximum of times to avail with this card'}
                label={'Maximum of times to avail with this card'}
                paddingVertical={8}
                value={value?.maxLimit}
                onChangeText={onMaxLimitChange}
                editable={!disabled}
                rightComponent={lockComp()}
                touched
                labelPaddingBottom={10}
                minHeight={24}
                {...styles.textinputStyle}
                placeholderTextColor={'PRIMARY_GREY'}
              />
            </Box>
          </ModBox>
          {paymentMode === 'No Cost EMI' && <Spacer size={16} direction={'vertical'} />}
          <ModBox show={paymentMode === 'Card' && purchaseType?.includes('EMI Purchase')} h={72} flexDirection={'row'}>
            <Box f={0.5} h={72}>
              <MultiselectDropdown
                label={'EMI Bank *'}
                data={getInstruments('bankEmiId')}
                touched
                isMultiSelect={true}
                fieldName={'emiBankName'}
                fontFamily={'jiotype-medium'}
                setFieldValue={(_, val: any) => handleEmiBankChange(val)}
                value={emiBankName}
                checkboxColor={Colors.BG_BLUE as ColorOptions}
                selectedTextBackgroundClor={Colors.BG_BLUE_LIGHT as ColorOptions}
                selectedTextBorderColor={Colors.BORDER_LIGHT_BLUE as ColorOptions}
                error={ruleConfigErrors.emiBankName}
                disabled={disabled}
                selectAll={true}
                scrollViewId={'emibankslist-wrapper'}
              />
            </Box>
            <Spacer direction={'horizontal'} size={16} />
            <ModBox f={0.5} h={72} show={paymentMode === 'Card' && purchaseType?.includes('EMI Purchase')}>
              <MultiselectDropdown
                label={'EMI Tenure *'}
                data={tenureData}
                touched
                isMultiSelect={true}
                fieldName={'emiTenure'}
                setFieldValue={(_, val: any) => handleEmiTenureChange(val)}
                value={emiTenure}
                checkboxColor={Colors.BG_BLUE as ColorOptions}
                selectedTextBackgroundClor={Colors.BG_BLUE_LIGHT as ColorOptions}
                selectedTextBorderColor={Colors.BORDER_LIGHT_BLUE as ColorOptions}
                error={ruleConfigErrors.emiTenure}
                disabled={disabled}
                selectAll={true}
                scrollViewId={'emibankslist-wrapper'}
              />
            </ModBox>
          </ModBox>
          <Spacer size={8} direction={'vertical'} />
          {(paymentMode === 'Card' || paymentMode === 'No Cost EMI') && (
            <TextInputWithDelete
              label="Card BIN"
              placeholder={'Add Card Bin'}
              title={'Card BIN *'}
              fieldName="bin"
              onChangeText={onBinChange}
              touched
              isEmail={false}
              error={ruleConfigErrors.bin}
              value={value?.bin}
              {...styles.textinputStyle}
              setFieldValue={onBinChange}
              setValuesOnFieldNameObject={true}
              bgColor={Colors.BG_BLUE_LIGHT as ColorOptions}
              color={Colors.BG_BLUE as ColorOptions}
              textWidth={150}
              borderRadius={40}
              rightComponent={lockComp()}
              innerRef={binRef}
            />
          )}
        </Box>
      </Box>
      <ModBox
        show={count < 1}
        testID="add-new-rule"
        onPress={handleAddNewRulePress}
        borderWidth={1}
        align={'center'}
        pv={12}
        borderRadius={4}
        borderColor={Colors.BORDER_LIGHT_BLUE as ColorOptions}
        marginTop={16}
        bg={'#E6EFFF' as ColorOptions}
        underlayColor={'TRANSPARENT'}
        borderStyle={'dashed'}>
        <Text
          title={'+ Add New Rule'}
          fontFamily={'jiotype-medium'}
          fontSize={12}
          color={Colors.BG_BLUE as ColorOptions}
        />
      </ModBox>
      <ModBox
        show={count > 0}
        borderWidth={1}
        borderColor={Colors.BORDER_LIGHT_BLUE as ColorOptions}
        borderRadius={4}
        marginTop={16}>
        <Box
          flexDirection={'row'}
          justify={'space-between'}
          align={'center'}
          pv={8}
          ph={12}
          borderTopRightRadius={4}
          borderTopLeftRadius={4}
          bg={Colors.BG_LIGHT_BLUE as ColorOptions}>
          <Text fontFamily={'jiotype-medium'} fontSize={12} color={'BLACK_21'}>
            RULE 02
          </Text>
          <Box p={8} onPress={handleRule2Collapse} testID="handleRule2Collapse" underlayColor={'TRANSPARENT'}>
            <Box bg={'PRIMARY_GREY'} w={12} h={1.5} />
          </Box>
        </Box>
        <Spacer size={16} direction={'vertical'} />
        <Box ph={16}>
          <Text
            fontFamily={'jiotype-medium'}
            fontSize={12}
            color={Colors.LABEL_GREY as ColorOptions}
            title={'Transaction / Event Type'}
          />
          <Spacer size={8} direction={'vertical'} />
          <Box borderWidth={1} borderColor={Colors.BORDER_LIGHT_BLUE as ColorOptions} ph={16} pv={12} borderRadius={4}>
            <Text fontFamily={'jiotype-medium'} fontSize={12} color={'BLACK_21'} title={'Product Purchase'} />
          </Box>
        </Box>
        <Box bg={Colors.BG_LIGHT_BLUE as ColorOptions} borderRadius={4} m={16} p={16}>
          {[...Array(count)].map((_, index: number) => (
            <TxnAttributeComp
              setFieldValue={setFieldValue}
              value={value}
              updateProductSelection={updateProductSelection}
              products={products}
              index={index}
              updateRuleConfigError={updateRuleConfigError}
              ruleConfigErrors={ruleConfigErrors}
              key={'txnAttributeComp' + index}
            />
          ))}
          <ModBox
            show={products?.length > 0}
            onPress={() => setAttributesCount(count <= 5 ? count + 1 : count)}
            testID="add-txn-attr"
            borderWidth={1}
            align={'center'}
            pv={8}
            borderRadius={4}
            borderColor={Colors.BORDER_LIGHT_BLUE as ColorOptions}
            marginTop={16}
            bg={'#E6EFFF' as ColorOptions}
            underlayColor={'TRANSPARENT'}
            borderStyle={'dashed'}>
            <Text
              title={'+ Add Transaction Attributes'}
              fontFamily={'jiotype-medium'}
              fontSize={12}
              color={Colors.BG_BLUE as ColorOptions}
            />
          </ModBox>
        </Box>
      </ModBox>
    </Box>
  )
}

const styles = {
  textinputStyle: {
    type: 'body12',
    labelPaddingBottom: 8,
    borderRadius: 4,
    labelFontFamily: 'jiotype-medium',
    labelColor: Colors.LABEL_GREY as ColorOptions,
    labelFontSize: 12,
    fontSize: 12,
    selectionColor: 'BLUE',
    paddingHorizontal: 8,
    borderColor: Colors.BORDER_LIGHT_BLUE as ColorOptions,
    focusBorderColor: Colors.BORDER_LIGHT_BLUE as ColorOptions,
    fontFamily: 'jiotype-medium',
    placeholderTextColor: Colors.LABEL_GREY as ColorOptions,
    color: Colors.FONT_BLACK as ColorOptions,
  } as TextInputNewProps,
}
